export function sumFirstI(array: any[], i: any): number {
  return array.reduce(
    (a, b, j) =>
      j <= i
        ? +parseFloat(a).toFixed(2) + +parseFloat(b).toFixed(2)
        : +parseFloat(a).toFixed(2),
    0
  );
}
